export const KEY = "data-skeleton-type";
export const KEY_EXCLUDE = "data-skeleton-exclude-type";
export const LIST_NUM = "data-skeleton-list-num";

export enum SKELETON_TYPE {
  IGNORE = "ignore",
  TEXT = "text",
  IMAGE = "img",
  BLOCK = "block",
  SUB_BLOCK = "sub-block",
  BORDER = "border",
  LIST = "list",
  LIST_ITEM = "list-item",
  BUTTON = "button",
  BACKGROUND = "background",
  BACKGROUND_IMAGE = "background-image",
  BACKGROUND_COLOR = "background-color",
  INPUT = "input"
}
